"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _material = require("@mui/material");

var _xDatePickers = require("@mui/x-date-pickers");

var _AdapterMoment2 = require("@mui/x-date-pickers/AdapterMoment");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton"));

var _ReadOnlyField = _interopRequireDefault(require("../ReadOnlyField/ReadOnlyField"));

var _utils = require("./utils");

var _MaskedTextField = _interopRequireDefault(require("./MaskedTextField"));

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CalendarPicker = (0, _material.styled)(_xDatePickers.CalendarPicker)(function () {
  return {
    ".PrivatePickersSlideTransition-root": {
      minHeight: 230
    }
  };
});
var MuiBox = (0, _material.styled)(_material.Box)(function () {
  return {
    marginBottom: 10,
    marginRight: 20,
    textAlign: "right"
  };
});
var TimezoneDisplay = (0, _material.styled)("div")(function () {
  return {
    lineHeight: 1
  };
});
var Autocomplete = (0, _material.styled)(_material.Autocomplete)(function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  return {
    "&.MuiAutocomplete-root": {
      padding: "10px 20px"
    },
    ".MuiInput-input": {
      padding: "0.4rem ".concat(theme.spacing(2), " 0.4rem ").concat(theme.spacing(2), " !important")
    },
    ".MuiInputBase-root": {
      "&:hover": {
        borderColor: disabled ? theme.palette.brand.grey.stone : undefined
      }
    }
  };
});
var format = "YYYY-MM-DD hh:mm A";

var getDateOrTimeFromMoment = function getDateOrTimeFromMoment(date) {
  var withDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var currentTime = date.format("HH:mm"); // eslint-disable-next-line prefer-const

  var _currentTime$split = currentTime.split(":"),
      _currentTime$split2 = (0, _slicedToArray2.default)(_currentTime$split, 2),
      hour = _currentTime$split2[0],
      minutes = _currentTime$split2[1];

  minutes = Number(minutes) < 30 ? "00" : "30";

  if (withDate) {
    return date.set("hour", +(hour || 0)).set("minutes", +(minutes || 0)).set("seconds", 0).format(format);
  }

  return "".concat(hour, ":").concat(minutes);
};

var _AdapterMoment = new _AdapterMoment2.AdapterMoment({
  instance: _momentTimezone.default
}),
    moment = _AdapterMoment.moment;

var DateTimePicker = function DateTimePicker(_ref2) {
  var onChange = _ref2.onChange,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? null : _ref2$value,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$DatePickerProps = _ref2.DatePickerProps,
      DatePickerProps = _ref2$DatePickerProps === void 0 ? {} : _ref2$DatePickerProps,
      _ref2$AutoCompletePro = _ref2.AutoCompleteProps,
      AutoCompleteProps = _ref2$AutoCompletePro === void 0 ? {} : _ref2$AutoCompletePro,
      _ref2$PopoverProps = _ref2.PopoverProps,
      PopoverProps = _ref2$PopoverProps === void 0 ? {} : _ref2$PopoverProps,
      _ref2$MaskedTextField = _ref2.MaskedTextFieldProps,
      MaskedTextFieldProps = _ref2$MaskedTextField === void 0 ? {} : _ref2$MaskedTextField,
      _ref2$TextButtonProps = _ref2.TextButtonProps,
      TextButtonProps = _ref2$TextButtonProps === void 0 ? {} : _ref2$TextButtonProps,
      label = _ref2.label,
      labels = _ref2.labels,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? "" : _ref2$placeholder,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$helperText = _ref2.helperText,
      helperText = _ref2$helperText === void 0 ? "" : _ref2$helperText,
      _ref2$fullWidth = _ref2.fullWidth,
      fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth,
      _ref2$disablePast = _ref2.disablePast,
      disablePast = _ref2$disablePast === void 0 ? false : _ref2$disablePast,
      _ref2$readOnly = _ref2.readOnly,
      readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
      id = _ref2.id,
      _ref2$required = _ref2.required,
      required = _ref2$required === void 0 ? false : _ref2$required,
      timezone = _ref2.timezone;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showPicker = _useState2[0],
      setShowPicker = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      calendarDate = _useState4[0],
      setCalendarDate = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      time = _useState6[0],
      setTime = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      pickerState = _useState8[0],
      setPickerState = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      displayDate = _useState10[0],
      setDisplayDate = _useState10[1];

  var inputRef = (0, _react.useRef)(null);
  var staticId = (0, _react.useMemo)(function () {
    return id || (0, _utilities.generateId)();
  }, [id]);
  var onPopoverClose = (0, _react.useCallback)(function () {
    setShowPicker(false);
    setPickerState(false);
  }, [setShowPicker, setPickerState]);
  var setCurrentTime = (0, _react.useCallback)(function () {
    var now = moment.tz(timezone);
    var currentTime = getDateOrTimeFromMoment(now);
    var currentDate = getDateOrTimeFromMoment(now, true);
    setCalendarDate(moment.tz(currentDate, format, true, timezone));
    setTime(currentTime);
    setPickerState(true);
  }, [setCalendarDate, setTime, setPickerState, timezone]);
  var setValuesFromMoment = (0, _react.useCallback)(function (dateObj) {
    setCalendarDate(dateObj);
    var valueTime = getDateOrTimeFromMoment(dateObj);
    var valueFromDate = getDateOrTimeFromMoment(dateObj, true);
    setDisplayDate(valueFromDate);
    setTime(valueTime);
  }, [setCalendarDate, setDisplayDate, setTime]);
  var selectedTime = (0, _react.useMemo)(function () {
    var slots = (0, _utils.getTimeSlots)();
    return slots.find(function (slot) {
      return slot.value === (time || "");
    }) || null;
  }, [time]);
  (0, _react.useEffect)(function () {
    if (value && moment.isMoment(value) && value.isValid()) {
      setValuesFromMoment(value);
    }
  }, [value, setCalendarDate, setDisplayDate, setTime, setValuesFromMoment]);
  (0, _react.useEffect)(function () {
    if (pickerState && calendarDate && time && moment.isMoment(calendarDate)) {
      var _time$split = time.split(":"),
          _time$split2 = (0, _slicedToArray2.default)(_time$split, 2),
          hour = _time$split2[0],
          minutes = _time$split2[1];

      calendarDate.set("hour", +(hour || 0)).set("minutes", +(minutes || 0)).set("seconds", 0);
      onChange(calendarDate);
      setValuesFromMoment(calendarDate);
      onPopoverClose();
    }
  }, [pickerState, onChange, calendarDate, time, onPopoverClose, setValuesFromMoment]);

  var onDateChange = function onDateChange(newDate) {
    setCalendarDate(newDate);

    if (time) {
      setPickerState(true);
    }
  };

  var onTimeChange = function onTimeChange(timeVal) {
    setTime(timeVal || "");

    if (timeVal && calendarDate) {
      setPickerState(true);
    }
  };

  var onAccept = function onAccept(val) {
    var newObj = moment.tz(val, format, true, timezone);
    setDisplayDate(val);

    if (val.endsWith("A") || val.endsWith("P")) {
      return;
    }

    if (val === "") {
      setCalendarDate(null);
      setTime("");
      onChange(null);
    } else {
      onChange(newObj);
    }
  };

  var blocksPattern = (0, _react.useMemo)(function () {
    return (0, _utils.blocks)(disablePast);
  }, [disablePast]);
  var slots = (0, _utils.getTimeSlots)();

  if (readOnly) {
    var content = value ? moment.tz(value, timezone).format(format) : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReadOnlyField.default, {
      content: content,
      label: label
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MaskedTextField.default, _objectSpread(_objectSpread({}, MaskedTextFieldProps), {}, {
      InputProps: {
        endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [value && /*#__PURE__*/(0, _jsxRuntime.jsx)(TimezoneDisplay, {
            children: moment.tz(timezone).format("z")
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
            disabled: disabled,
            onClick: function onClick() {
              return setShowPicker(function (prev) {
                return !prev;
              });
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              iconName: "calendar-alt"
            })
          })]
        }),
        ref: inputRef
      },
      disabled: disabled,
      error: error,
      fullWidth: fullWidth,
      helperText: helperText,
      id: staticId,
      label: label,
      mask: "YYYY-MM-DD hh:mm AP",
      blocks: blocksPattern,
      onAccept: onAccept,
      placeholder: placeholder,
      required: required,
      unmask: false,
      value: displayDate
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Popover, _objectSpread(_objectSpread({}, PopoverProps), {}, {
      anchorEl: inputRef.current,
      anchorOrigin: {
        horizontal: "left",
        vertical: "bottom"
      },
      onClose: onPopoverClose,
      open: showPicker,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_xDatePickers.LocalizationProvider, {
        dateAdapter: _AdapterMoment2.AdapterMoment,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CalendarPicker, _objectSpread(_objectSpread({}, DatePickerProps), {}, {
          date: calendarDate,
          disablePast: disablePast // @ts-ignore: This does exist according to https://mui.com/x/api/date-pickers/calendar-picker/
          ,
          disabled: disabled,
          onChange: onDateChange
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          sx: {
            fontSize: "0.875rem",
            fontWeight: "bold",
            paddingLeft: "20px"
          },
          children: labels.time
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Autocomplete, _objectSpread(_objectSpread({}, AutoCompleteProps), {}, {
          disabled: disabled,
          filterSelectedOptions: true,
          getOptionLabel: function getOptionLabel(option) {
            return option.label;
          },
          isOptionEqualToValue: function isOptionEqualToValue(option) {
            return option.value === time;
          },
          onChange: function onChange(_, value) {
            return onTimeChange(value === null || value === void 0 ? void 0 : value.value);
          },
          options: slots,
          renderInput: function renderInput(params) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, _objectSpread({
              placeholder: labels.timePlaceholder
            }, params));
          },
          value: selectedTime
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(MuiBox, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.default, _objectSpread(_objectSpread({}, TextButtonProps), {}, {
            label: labels.currentTime,
            onClick: setCurrentTime,
            variant: "contained"
          }))
        })]
      })
    }))]
  });
};

var _default = DateTimePicker;
exports.default = _default;